/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Flag from './flag-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Flag {...validProps} />;
}
SvgComponent.iconName = 'flag';

export const FlagIcon = svgIconWrapper(SvgComponent);
